export const foodTypes = ["generic", "branded", "recipe", "recipe_variation"] as const;
export type FoodType = (typeof foodTypes)[number];

export const foodModifiers = [
  "fresh",
  "raw",
  "cooked",
  "roasted",
  "grilled",
  "fried",
  "boiled",
  "steamed",
  "baked",
  "frozen",
  "canned",
  "dried",
  "smoked",
  "cured",
  "pickled",
] as const;
export type FoodModifier = (typeof foodModifiers)[number];

export const servingModifiers = [
  "diced",
  "chopped",
  "minced",
  "sliced",
  "cubed",
  "shredded",
  "mashed",
  "pureed",
  "crushed",
  "crumbled",
  "crumbs",
  "drained",
  "boneless",
  "packed",
  "unpopped",
] as const;
export type ServingModifier = (typeof servingModifiers)[number];
